module.exports = __webpack_public_path__ + "img/No-internet-connection.f4803888.png";